/**
 * Method to capitalise first letter of an input string
 * @param text {String} - the input string
 * @return {String}
 */
export const uppercaseFirstLetter = (text: string): string =>
	typeof text === 'string' ? text.charAt(0).toUpperCase() + text.substr(1) : '';

/**
 * Capitalise first letter of all words in a given text
 * @param text
 */
export const toTitleCase = (text: string): string => {
	if (typeof text !== 'string') {
		return '';
	}

	const words = text.split(' ');
	return words.map((word) => uppercaseFirstLetter(word)).join(' ');
};

/**
 * Replace underscores (_) with an empty space
 */
export const replaceUnderscoresToSpace = (text: string): string =>
	typeof text === 'string'
		? text
				// underscores to spaces
				.replace(/_/g, ' ')
				// spaces to space
				.replace(/ +/g, ' ')
		: '';

/**
 * Replace underscores (- or _) with an empty space
 */
export const replaceHypensToSpace = (text: string): string =>
	typeof text === 'string'
		? text
				// underscores to spaces
				.replace(/-/g, ' ')
				// spaces to space
				.replace(/ +/g, ' ')
		: '';
